import React from "react";
import logo from "../Images/ubiqdlogo.png";

export default function Contact(props) {
  return (
    <div className="ContactContainer">
      <h3 className="Interested">Interested?</h3>
      <div className="NextStepsButtons">
        <form
          action="https://share.hsforms.com/1wcSheeF8RRi2kv-tw4jqCA50gmq?__hstc=267255377.c4227c414cea499de4a7218079baadd7.1642792911568.1650313272090.1650467576759.41&__hssc=267255377.3.1650467576759&__hsfp=2396741733"
          method="get"
          target="_blank"
        >
          <button className="PilotProgramButton" type="submit">
            Apply to be in our Pilot Program
          </button>
        </form>
        <form action="https://ubigro.com/product/" method="get" target="_blank">
          <button className="ProductButton" type="submit">
            More Product Information
          </button>
        </form>
        <form
          action="https://ubigro.com/case-studies/"
          method="get"
          target="_blank"
        >
          <button className="CaseStudiesButton" type="submit">
            Read Case Studies
          </button>
        </form>
        <form
          action="https://img1.wsimg.com/blobby/go/e91a4987-3726-410f-8e4a-95cd1495a184/downloads/UbiGro%20White%20Paper_All_FullColor_EB050120.pdf?ver=1589220731742"
          method="get"
          target="_blank"
        >
          <button className="WhitePaperButton" type="submit">
            Download UbiGro White Paper
          </button>
        </form>
      </div>

      <p className="ContactUs">Contact Us:</p>
      <div className="EachContactContainer">
        <p className="ContactHeader">Email:</p>
        <p className="ContactInfo">sales@ubigro.com</p>
      </div>
      <div className="EachContactContainer">
        <p className="ContactHeader">Phone:</p>
        <p className="ContactInfo">+1 (505) 310-6766</p>
      </div>
      <div className="EachContactContainer">
        <p className="ContactHeader">Website:</p>
        <p className="ContactInfo"> ubigro.com</p>
      </div>
      <img className="UbiQDLogo" src={logo} alt="UbiQD Logo"></img>
    </div>
  );
}
